import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router, RouterLink } from '@angular/router'
import {
  IonApp,
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonRouterOutlet,
  IonToolbar,
  Platform,
} from '@ionic/angular/standalone'
import { SplashScreen } from '@capacitor/splash-screen'
import { Subscription } from 'rxjs'
import { v4 } from 'uuid'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    IonApp,
    IonHeader,
    IonToolbar,
    IonContent,
    IonFooter,
    IonButton,
    IonButtons,
    IonRouterOutlet,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  private backButton: Subscription | undefined = undefined
  public isDesktop: boolean | undefined = undefined

  constructor(
    private readonly platform: Platform,
    private readonly router: Router
  ) {
    this.isDesktop = this.isDesktop =
      platform.is('desktop') || platform.is('tablet')

    SplashScreen.show()
    if (!localStorage.getItem('appUUID')) {
      const appUUID = v4().replace(/-/g, '')
      localStorage.setItem('appUUID', appUUID)
    }
  }

  ngOnInit(): void {
    this.backButton = this.platform.backButton.subscribeWithPriority(
      9999,
      () => {
        this.router.navigate([''])
      }
    )
  }

  ngOnDestroy(): void {
    this.backButton?.unsubscribe()
  }

  navigateTo(path: string): void {
    this.router.navigate([path])
  }
}
